import { MenuItem, TextField } from '@mui/material';
import { NotificationType } from 'features/notifications/notifications.types';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type InitialReportNotificationTypeFieldProps = {
  label: string;
  canSendCritical: boolean;
};

export const InitialReportNotificationTypeField = (
  props: InitialReportNotificationTypeFieldProps,
): JSX.Element => {
  const { label, canSendCritical } = props;
  const { control, formState } = useFormContext();
  const { t } = useTranslation();

  const notificationTypes = [
    NotificationType.Normal,
    ...(canSendCritical ? [NotificationType.Critical] : []),
  ];

  return (
    <Controller
      name="reportNotificationType"
      control={control}
      render={({ field, fieldState }): JSX.Element => {
        const { ref, ...muiFieldProps } = field;
        return (
          <TextField
            select
            id="field-control-reportNotificationType"
            label={label}
            fullWidth
            {...muiFieldProps}
            value={canSendCritical ? field.value : NotificationType.Normal}
            inputRef={ref}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
            required
            sx={{ textTransform: 'capitalize' }}
            disabled={!canSendCritical || formState.isSubmitting}
          >
            {notificationTypes.map((notifType) => (
              <MenuItem
                key={notifType}
                value={notifType}
                sx={{ textTransform: 'capitalize' }}
              >
                {t(`common.${notifType}`)}
              </MenuItem>
            ))}
          </TextField>
        );
      }}
    />
  );
};
